import { EditorAPIKey, ScrollApiKey } from '@/apis';
import { createScrollApi } from './scrollApi';

import type { EntryPoint } from '@/apilib';

export const ScrollApiEntryPoint: EntryPoint = {
  name: 'ScrollApi',
  declareAPIs: () => [ScrollApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  async attach(shell) {
    shell.contributeAPI(ScrollApiKey, () => createScrollApi(shell));
  },
};
